import ErrorHandler from "./errorHandle";
import { handleCaptcha } from "./handleCaptcha";
import { handleGDTokenExpired, handleHBLoginExpired } from "./handleLogin";
import { handlePermission } from "./handlePermission";
import { handleSpaceErr } from "./handleSpaceErr";
import { handleUserNotInOrg } from "./handleUserNotInOrg";

const errorHandler = new ErrorHandler();

errorHandler.registerCustomHandler(handleCaptcha);
errorHandler.registerCustomHandler(handlePermission);
errorHandler.registerCustomHandler(handleSpaceErr);
errorHandler.registerCustomHandler(handleUserNotInOrg);
errorHandler.registerCustomHandler(handleGDTokenExpired);
errorHandler.registerCustomHandler(handleHBLoginExpired);

export default errorHandler;
